import { getChartTracks } from '../utils/getChartTracks.js'

export default function useChart(props, trackCount) {
  const chart = computed(() => props.item.enrichment.chart)
  const tracks = computed(() => getChartTracks(props.item.enrichment.chart, trackCount))
  const currentPosition = computed(() => props.item?.enrichment?.chart?.currentPosition)

  const currentTextColor = (track, fallback = 'text-q-cr-red-primary') => {
    return track?.position === currentPosition.value ? 'text-white' : fallback
  }

  return { chart, tracks, currentPosition, currentTextColor }
}
